import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import api, { getToken, clearToken } from "./api";

export default function ProtectedRoute() {
  const [state, setState] = useState("checking");

  useEffect(() => {
    if (!getToken()) {
      setState("no");
      return;
    }
    api
      .get("/auth/me")
      .then(() => setState("yes"))
      .catch(() => {
        clearToken();
        setState("no");
      });
  }, []);

  if (state === "checking")
    return (
      <div className="flex min-h-screen items-center justify-center bg-ink">
        <div className="h-10 w-10 animate-spin rounded-full border-2 border-gold/20 border-t-gold" data-testid="auth-loading" />
      </div>
    );
  if (state === "no") return <Navigate to="/panel/login" replace />;
  return <Outlet />;
}
